import React, { useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie, Doughnut } from 'react-chartjs-2';
import { inputStyle, label, subTitle, title } from '../utils/style';
import Input from "../reusable_components/Input";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { setLoader } from '../reusable_components/Loader';
import { url } from "../utils/config";
import axios from "axios";

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
    labels: ['Operating Expense', 'Revenue Generated', 'Forecasted Revenue'],
    datasets: [
        {
            label: 'Revenue',
            data: [15000, 30000, 100000],
            backgroundColor: [
                '#4C78FF',
                '#16DBCC',
                '#FFBB38'
            ],
            borderColor: [
                '#4C78FF',
                '#16DBCC',
                '#FFBB38'
            ],
            borderWidth: 1,
        },
    ],
};




function Revenue() {
    const [yearList, setYearList] = useState(['2023-2024', '2024-2025', '2025-2026'])
    const [formInput, setFormInput] = useState({ start: '', end: '' });
    const [inputErrors, setInputErrors] = useState([]);
    const [missingFields, setMissingFields] = useState([]);

    const inputEvent = (e) => {
        const { name, value } = e.target;

        if ((name === 'start' || name === 'end') && value.length > 10) {
            return
        }
        setFormInput((old) => {
            return {
                ...old,
                [name]: value,
            };
        });
    };

    const getTotalServiceCost = (pilot_estimate) => {
        if (!pilot_estimate?.bundleList) return 0
        return JSON.parse(pilot_estimate.bundleList).data.reduce((sum, service) => sum + (+service.cost), 0).toFixed(2)
    };


    const downloadInvoice = async () => {
        let missed = []
        !formInput.start && missed.push('start')
        !formInput.end && missed.push('end')
        if (missed.length > 0) {
            setMissingFields(missed)
            return
        }
        setMissingFields([])

        try {
            setLoader(true)

            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.post(url + '/invoice_excel_data', formInput, { headers })

            // const taxRateValue = (+data.defaultTax) / 100

            const jsonData = await Promise.all(data.data?.map(async (item) => {
                const labourCost = +item.pilot_estimate?.totalCost || 0;
                const materialCost = +item.pilot_estimate?.materialCost || 0;
                const serviceCost = await getTotalServiceCost(item.pilot_estimate);
                const subtotal = +((+materialCost) + (+labourCost) + (+serviceCost)) || 0;
                const totalTax = +item.pilot_estimate?.tax || 0;

                return {
                    "Estimate Number": '00000' + item.id,
                    "Estimate Date": item.date,
                    "Customer Name": item.pilot_user?.name,
                    "Customer Email": item.pilot_user?.email,
                    "Customer Phone": item.pilot_user?.phone,
                    "Make": item.make,
                    "Model": item.model,
                    "Year": item.year,
                    "Problem Description": item.problemDescription,
                    "Labour Cost": `$${labourCost}`,
                    "Service Cost": `$${serviceCost}`,
                    "Parts Cost": `$${materialCost?.toFixed(2)}`,
                    "Subtotal": `$${subtotal?.toFixed(2)}`,
                    "Taxes": `$${totalTax?.toFixed(2)}`,
                    "Total": `$${(subtotal + totalTax)?.toFixed(2)}`,
                    "Status": item.pilot_estimate?.status,
                }
            }));


            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(jsonData);

            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            const dataBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(dataBlob);
            link.download = "Invoice_Report.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setMissingFields([])
            setFormInput({ start: '', end: '' })
        } catch (error) {
            console.log(error)
            toast.error('Could not download incoive', { autoClose: 3000 });
        } finally {
            setLoader(false)
        }
    }

    return (
        <div className="p-4">
            <div className={`${title} mb-4`}>Finance</div>
            <div className="grid grid-cols-2">
                <div className="col-span-1 border-r border-gray-300">
                    <div className='w-1/2 flex gap-8'>
                        <span className={subTitle}>FY</span>
                        <select className={inputStyle}>
                            {
                                yearList.map((yr, ind) => <option key={ind}>{yr}</option>)
                            }
                        </select>
                    </div>
                    <div className='px-24 '>
                        <Doughnut data={data} />
                    </div>
                </div>
                <div className="col-span-1">
                    <div className='flex flex-col gap-2 items-center'>
                        <div className='flex flex-col gap-2 w-2/3' >
                            <div>
                                <label className={label}>
                                    Start Date
                                </label>
                                <Input
                                    id="start"
                                    name="start"
                                    type="date"
                                    placeHolder={'Start Date'}
                                    required={true}
                                    index={1}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    className={inputStyle}
                                    value={formInput.start}
                                    onChange={inputEvent}
                                // max={new Date().toISOString().split("T")[0]}
                                />
                            </div>
                            <div>
                                <label className={label}>
                                    End Date
                                </label>
                                <Input
                                    id="end"
                                    name="end"
                                    type="date"
                                    placeHolder={'End Date'}
                                    required={true}
                                    index={2}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    className={inputStyle}
                                    value={formInput.end}
                                    onChange={inputEvent}
                                // max={new Date().toISOString().split("T")[0]}
                                />
                            </div>
                        </div>
                        <button
                            className={'mt-2 border border-customOne text-sm rounded-lg p-2 px-4 text-center text-customOne font-semibold cursor-pointer hover:bg-customOne hover:text-white'}
                            onClick={() => downloadInvoice()}
                        >
                            Download Invoice Report
                        </button>
                    </div>

                    <div className="mt-4 py-4 px-12">
                        <div className="flex p-2 border border-gray-300">
                            <div className='basis-1/2 text-center text-sm font-semibold'>Revenue Item</div>
                            <div className='basis-1/2 text-center text-sm font-semibold'>Cost</div>
                        </div>
                        <div className="flex p-2 border border-gray-300 text-xs">
                            <div className='basis-1/2 text-center'>Operating Expense</div>
                            <div className='basis-1/2 text-center'>$15,000.00</div>
                        </div>
                        <div className="flex p-2 border border-gray-300 text-xs">
                            <div className='basis-1/2 text-center'>Revenue Generated</div>
                            <div className='basis-1/2 text-center'>$30,000.00</div>
                        </div>
                        <div className="flex p-2 border border-gray-300 text-xs">
                            <div className='basis-1/2 text-center'>Forecasted Revenue</div>
                            <div className='basis-1/2 text-center'>$1,00,000.00</div>
                        </div>
                        <div className={subTitle}>Inventory Levels</div>
                        <div className="flex p-2 border border-gray-300">
                            <div className='basis-1/2 text-center text-sm font-semibold'>Location</div>
                            <div className='basis-1/2 text-center text-sm font-semibold'>Level</div>
                        </div>
                        <div className="flex p-2 border border-gray-300 text-xs">
                            <div className='basis-1/2 text-center'>Loc 1</div>
                            <div className='basis-1/2 text-center'>05%</div>
                        </div>
                        <div className="flex p-2 border border-gray-300 text-xs">
                            <div className='basis-1/2 text-center'>Loc 2</div>
                            <div className='basis-1/2 text-center'>10%</div>
                        </div>
                        <div className="flex p-2 border border-gray-300 text-xs">
                            <div className='basis-1/2 text-center'>Loc 3</div>
                            <div className='basis-1/2 text-center'>08%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Revenue;